import styled from "styled-components";

export const FilterPlansContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 320px;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FilterTitle = styled.h3`
  margin: 0;
  font-weight: 900;
  font-size: 16px;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.85);
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CriteriaLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NewIcon = styled.img`
  height: 14px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
`;

export const InfoIconImg = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
`;

export const InfoButton = styled.button`
  width: 16px;
  height: 16px;
  cursor: pointer;
  color: #757575;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }

  &:focus {
    outline: 2px solid #4a90e2;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const TooltipContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #1a7971;
  border: 4px solid #1a7971;
  color: #ffffff;
  border-radius: 4px;
  padding: 8px;
  box-shadow: none;
  z-index: 1000;
  width: 247px;
  max-width: 247px;
  white-space: normal;
  word-wrap: break-word;

  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid #1a7971;
  }
`;

export const TooltipText = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const SumInsuredSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SumInsuredButton = styled.button<{ isSelected?: boolean }>`
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid ${(props) => (props.isSelected ? "#008CFF" : "#E2E2E2")};
  background: ${(props) => (props.isSelected ? "#F8FBFF" : "#FFFFFF")};
  color: ${(props) => (props.isSelected ? "#008CFF" : "#4A4A4A")};
  font-weight: ${(props) => (props.isSelected ? 900 : 400)};
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #008cff;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #f2f2f2;
  border: 1px solid #d8d8d8;
`;
